import { ReactNode } from 'react';
import { UnitStatusSearchTabsProvider } from './unit-status-search-tabs-provider';

export function UnitStatusSearchProvider({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) {
    return (
        <UnitStatusSearchTabsProvider initialTab={initialTab}>
            {children}
        </UnitStatusSearchTabsProvider>
    );
}
